// extracted by mini-css-extract-plugin
module.exports = {"cardRow":"CrossSegmentCard-CardRow-module--card-row--4hJPU"};